import { createSelector } from '@ngrx/store';
import { selectClientPersonalInfoData } from 'vg-interaction-model/dist';

import * as fromFeature from '../../reducers/index';
import {
  getClientDateOfBirth,
  getClientEmailAddress,
  getClientIncapacitated,
  getClientName,
  getClientSegment,
  getLast4IdOnFile,
} from '../../reducers/personal-data/personal-data.reducer';

// TODO-Personal Info Refactor: Replace these selectors with the VGIMPersonalInfoClient slice equivalents
export const selectPersonalDataState = createSelector(
  fromFeature.getPersonalDataState,
  (state) => state,
);
export const selectClientSegment = createSelector(selectPersonalDataState, getClientSegment);

export const selectPersonalDataLoaded = createSelector(
  fromFeature.getPersonalDataState,
  (state) => state.loaded,
);
export const selectClientIncapacitated = createSelector(
  selectPersonalDataState,
  getClientIncapacitated,
);

// TODO-Personal Info Refactor: Replace these selectors with the VGIM SSN slice equivalents
export const selectLast4IdOnFile = createSelector(selectPersonalDataState, getLast4IdOnFile);

// Selects the client name from the VGIMPersonalInfoClient slice of state
export const selectClientName = createSelector(selectClientPersonalInfoData, getClientName);
export const selectClientDateOfBirth = createSelector(
  selectClientPersonalInfoData,
  getClientDateOfBirth,
);
export const selectClientEmailAddress = createSelector(
  selectClientPersonalInfoData,
  getClientEmailAddress,
);
export const selectClientFlagDigitalAdvise = createSelector(
  selectPersonalDataState,
  ({ digitalAdviseService }) => digitalAdviseService,
);
